import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Icon } from 'antd';
import WebsocketUtil from '../../utils/webSocket';
import { getStore } from '../../utils/localStorage';
import MessageRemind from './messageRemind';
import User from './user';
import EditPassword from './editPassword';
// import http from '../../utils/server/http';

import styles from './index.module.less';

class Header extends Component {
  static propTypes = {
    menuCollapsed: PropTypes.func.isRequired,
    collapsed: PropTypes.bool.isRequired,
  }

  constructor(props) {
    super(props);
    this.socketConnected = this.socketConnected.bind(this);
    this.scheduleReconnect = this.scheduleReconnect.bind(this);
    this.toggleCollapsed = this.toggleCollapsed.bind(this);
    this.reconnectTimer = null;
    this.reconnectRetry = 0;
    this.state = {
      visible: false
    }
  }

  componentDidMount() {
    this.socketConnected();
  }

  componentWillUnmount() {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }
  }

  /**
   * 建立全局socket连接
   */
  socketConnected = () => {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }
    if (global.socket) {
      return;
    }
    const token = getStore('token');
    if (!token) {
      return;
    }
    const headers = { access_token: token };
    const socket = new WebsocketUtil();
    socket.init(`/sms?access_token=${token}`, headers, () => {
      global.socket = socket;
      this.reconnectRetry = 0;
      console.log('连接', socket);
    }, () => {
      global.socket = null;
      console.log('连接断开');
      this.scheduleReconnect();
    });
  }

  /**
   * 断线后按指数退避重连（最长 30 秒一次）
   * 后端重启/发布后浏览器端会自动恢复，否则原始数据、位置信息、指令应答等
   * 依赖服务端按用户推送的功能会永久失效（页面看起来"连着"，实际收不到任何数据）
   */
  scheduleReconnect = () => {
    if (this.reconnectTimer) {
      return;
    }
    const delay = Math.min(30000, 2000 * Math.pow(1.5, this.reconnectRetry || 0));
    this.reconnectRetry = (this.reconnectRetry || 0) + 1;
    console.log(`WebSocket ${delay}ms 后重连(第 ${this.reconnectRetry} 次)`);
    this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null;
      this.socketConnected();
    }, delay);
  }

  /**
   * 收缩菜单按钮点击事件
   */
  toggleCollapsed = () => {
    const { menuCollapsed } = this.props;
    menuCollapsed();
  }

  render() {
    const { collapsed, EditUserPassword, loginExit } = this.props;
    const { visible } = this.state;
    return (
      <div className={styles.header} style={collapsed ? { left: '80px' } : null}>
        <div className={styles['header-right']}>
          <span className={styles.trigger} onClick={this.toggleCollapsed}>
            <Icon type={collapsed ? 'menu-unfold' : 'menu-fold'} />
          </span>
          <div className={styles['header-right-components']}>
            <div>
              <MessageRemind visible={visible}/>
            </div>
            <div>
              <User changePassword={(v) => this.setState({visible: v})}/>
            </div>
          </div>
        </div>
        <EditPassword 
          EditUserPassword={EditUserPassword} 
          changePassword={(v) => this.setState({visible: v})} 
          visible={visible}
          loginExit={loginExit}
        />
      </div>
    );
  }
}

export default connect(
  state => ({
    collapsed: state.rootReducers.collapsed,
  }),
  dispatch => ({
    loginExit: () => {
      dispatch({ type: 'login/LOGIN_EXIT' });
    },
    menuCollapsed: () => {
      dispatch({ type: 'root/MENU_COLLAPSED_STATE' });
    },
    EditUserPassword: (param) => {
      dispatch({ type: 'login/LOGIN_EDIT_PASSWORD', param });
    },
  }),
)(Header);
